<template>
    <div class="flex flex-col gap-3 justify-center provider-card">
        <div
            class="w-full h-[120px] cursor-pointer"
            @click="handleClick"
        >
            <div class="w-full h-full rounded-[38px] relative overflow-hidden">
                <!-- Provider Image -->
                <img
                    :src="provider.image"
                    :alt="provider.name"
                    class="w-full h-full rounded-[38px] object-cover"
                />

                <!-- Border Overlay -->
                <img
                    src="https://www.burma368.net/static/image/home/game-item-border-image.png"
                    class="absolute top-0 left-0 w-full h-full pointer-events-none"
                    alt="border"
                />

                <!-- Play Icon -->
                <img
                    src="https://www.burma368.net/static/image/home/game-item-play.png"
                    class="w-[40px] h-[40px] absolute bottom-0 right-0 pointer-events-none"
                    alt="play"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderCardOld",
    props: {
        provider: {
            type: Object,
            required: true,
        },
        clickable: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        handleClick() {
            if (!this.clickable) return;
            // this.$router.push(`/user/slots?provider=${this.provider.code}`);
            this.$emit("click", this.provider);
        },
    },
};
</script>

<style scoped>
.provider-card:hover {
    transform: scale(1.03);
    transition: transform 0.2s ease;
}
</style>
